import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {FirmService} from '../services/firm.service';
import {AutomatService} from '../services/automat.service';

import {Firms} from '../models/firms';
import {SwalComponent} from '@sweetalert2/ngx-sweetalert2';
import {FirmGroupService} from '../services/firm-group.service';
import {Router} from '@angular/router';
import {NgxSpinnerService} from 'ngx-spinner';

@Component({
    selector: 'app-firm-groups',
    templateUrl: './firm-groups.component.html',
    styleUrls: ['./firm-groups.component.css']
})
export class FirmGroupsComponent implements OnInit {
    @ViewChild('closeCreateModal') closeCreateModal: ElementRef;
    @ViewChild('closeUpdateModal') closeUpdateModal: ElementRef;
    @ViewChild('errorSwal') private errorSwal: SwalComponent;
    @ViewChild('successSwal') private successSwal: SwalComponent;
    private firmId: string;
    public firm: Firms;
    public automatGroups = [];
    public groupsDetail = [];
    public haveNotAutomat = [];
    public orderedGroups: any[] = [];
    public selectedName;
    public selectedId;
    public searchText;
    public isCollaps = false;
    public selectedGroup = {name: ''};

    constructor(private firmService: FirmService,
                private automatService: AutomatService,
                private firmGroupService: FirmGroupService,
                private router: Router,
                private spinner: NgxSpinnerService,
    ) {
    }

    ngOnInit() {
        this.spinner.show();
        this.firmId = localStorage.getItem('firmId');
        this.getFirm(this.firmId);
        this.getAutomatGroupsByFirm(this.firmId);
        setTimeout(() => {
            /** spinner ends after 5 seconds */
            this.spinner.hide();
        }, 5000);
    }

    getFirm(firmId: string) {
        if (firmId === null) {
            this.firmService.getFirmsForSuperAdmin().subscribe(res => {
                this.firm = res;
                localStorage.setItem('firm', this.firm.name);
                console.log(this.firm);
            }, error => {
                if (error.message === 'Error: Access Denied') {
                    localStorage.removeItem('token');
                    localStorage.removeItem('user');
                    this.router.navigate(['/login']);
                } else {
                    this.errorSwal.title = error.status;
                    this.errorSwal.text = error.error;
                    this.errorSwal.show();
                }
            });
        } else {            
            this.firmService.getFirm(firmId).subscribe(res => {
                this.firm = res;
                localStorage.setItem('firm', this.firm.name);
                console.log(this.firm);
            }, error => {
                if (error.message === 'Error: Access Denied') {
                    localStorage.removeItem('token');
                    localStorage.removeItem('user');
                    this.router.navigate(['/login']);
                } else {
                    this.errorSwal.title = error.status;
                    this.errorSwal.text = error.error;
                    this.errorSwal.show();
                }
            });
        }
    }

    getAutomatGroupsByFirm(firmId: string) {
        this.groupsDetail = [];
        this.automatService.getAutomatGroupsByFirm(firmId).subscribe(res => {
            console.log(res);
            this.automatGroups = res.haveAutomats;
            this.haveNotAutomat = res.haveNotAutomats;
            for (const group of this.automatGroups) {
                this.groupsDetail.push(group._id.group[0]);
            }
            this.spinner.hide();
        }, error => {
            if (error.message === 'Error: Access Denied') {
                localStorage.removeItem('token');
                localStorage.removeItem('user');
                this.router.navigate(['/login']);
                this.spinner.hide();
            } else {
                this.errorSwal.title = error.status;
                this.errorSwal.text = error.error;
                this.errorSwal.show();
                this.spinner.hide();
            }
        });
    }

    createGroup(name) {
        if (name === '' || name === undefined) {
            this.errorSwal.title = 'Lütfen boş alan bırakmayınız!';
            this.errorSwal.show();
            return;
        }
        this.spinner.show();
        const AutomatGroup = {name: name, firm: this.firm._id};

        this.firmGroupService.createFirmGroup(AutomatGroup).subscribe(res => {
            console.log(res);
            this.successSwal.title = 'Başarılı!';
            this.successSwal.show();
            this.closeCreateModal.nativeElement.click();
            this.getAutomatGroupsByFirm(this.firmId);
            this.spinner.hide();
        }, error => {
            if (error.message === 'Error: Access Denied') {
                localStorage.removeItem('token');
                localStorage.removeItem('user');
                this.router.navigate(['/login']);
                this.spinner.hide();
            } else {
                this.errorSwal.title = error.status;
                this.errorSwal.text = error.error;
                this.errorSwal.show();
                this.spinner.hide();
            }
        });
    }

    deleteGroup(id) {
        if (id === '' || id === undefined) {
            this.errorSwal.title = 'Otomat id alınamadı!';
            this.errorSwal.show();
            return;
        }
        this.spinner.show();
        this.firmGroupService.deleteGroup(id).subscribe(res => {
            console.log(res);
            this.successSwal.title = 'Başarılı!';
            this.successSwal.show();
            this.getAutomatGroupsByFirm(this.firmId);
            this.spinner.hide();
        }, error => {
            if (error.message === 'Error: Access Denied') {
                localStorage.removeItem('token');
                localStorage.removeItem('user');
                this.router.navigate(['/login']);
                this.spinner.hide();
            } else {
                this.errorSwal.title = error.status;
                this.errorSwal.text = error.error;
                this.errorSwal.show();
                this.spinner.hide();
            }
        });
    }

    updateGroup(name) {
        if (name === '' || name === undefined) {
            this.errorSwal.title = 'Lütfen boş alan bırakmayınız!';
            this.errorSwal.show();
            return;
        }
        // this.spinner.show();
        const Group = {name: name};

        this.firmGroupService.updateGroup(Group, this.selectedId).subscribe(res => {
            console.log(res);
            this.successSwal.title = 'Başarılı!';
            this.successSwal.show();
            this.closeUpdateModal.nativeElement.click();
            this.getAutomatGroupsByFirm(this.firmId);
            this.spinner.hide();
        }, error => {
            if (error.message === 'Error: Access Denied') {
                localStorage.removeItem('token');
                localStorage.removeItem('user');
                this.router.navigate(['/login']);
                this.spinner.hide();
            } else {
                this.errorSwal.title = error.status;
                this.errorSwal.text = error.error;
                this.errorSwal.show();
                this.spinner.hide();
            }
        });
    }

    selected(id, name) {
        this.selectedId = id;
        this.selectedName = name;
    }

    checkCollapse(status: boolean) {
        this.isCollaps = !status;
        console.log(this.isCollaps);

    }
}



// WEBPACK FOOTER //
// /home/escobar/Documents/Projects/E-VEND/Srl-Evend/FE/superadmin/src/app/firm-groups/firm-groups.component.ts